module.exports = __webpack_public_path__ + "static/media/answers-profile-pic-4.6bd9bd47.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/answers-profile-pic-4.png
// module id = 1054
// module chunks = 0